import { render, staticRenderFns } from "./RegisterGroup.vue?vue&type=template&id=b0dd59d8&scoped=true&"
import script from "./RegisterGroup.vue?vue&type=script&lang=js&"
export * from "./RegisterGroup.vue?vue&type=script&lang=js&"
import style0 from "./RegisterGroup.vue?vue&type=style&index=0&id=b0dd59d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dd59d8",
  null
  
)

export default component.exports